import { useState } from "react";

export default function GenreSlider({ handleGenreClick }) {
    const [currentIndex, setCurrentIndex] = useState(0);
    const genres = ["Breakcore", "Rock", "Pop", "Jazz", "Hip-Hop", "Classical", "Electronic", "Reggae", "R&B", "Blues"];
    const [activeGenre, setActiveGenre] = useState(null);
    const handlePrevClick = () => {
        setCurrentIndex((prevIndex) => (prevIndex === 0 ? genres.length - 7 : prevIndex - 1));
    };

    const handleNextClick = () => {
        setCurrentIndex((prevIndex) => (prevIndex === genres.length - 7 ? 0 : prevIndex + 1));
    };
    const handleLabelClick = (genre) => {
        if (activeGenre === genre) {
            setActiveGenre(null);
            handleGenreClick(null);
        } else {
            setActiveGenre(genre);
            handleGenreClick(genre);
        }
    };
    return (
        <div className="genre-slider-container">
            <button className="arrow-btn left" onClick={handlePrevClick}>
                <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <rect width="40" height="40" rx="20" fill="#1F1F22" />
                    <rect x="0.5" y="0.5" width="39" height="39" rx="19.5" stroke="#EBEBFF" stroke-opacity="0.05" />
                    <g clip-path="url(#clip0_1_153)">
                        <path d="M22.0008 14.7998L16.8008 19.9998L22.0008 25.1998" stroke="#FCFCFC" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
                    </g>
                    <defs>
                        <clipPath id="clip0_1_153">
                            <rect width="16" height="16" fill="white" transform="translate(12 12)" />
                        </clipPath>
                    </defs>
                </svg>
            </button>
            <div className="genre-slider">
                {genres.slice(currentIndex, currentIndex + 7).map((genre, index) => (
                    <label
                        key={genre}
                        className={`genre-label ${activeGenre === genre ? "active" : ""}`}
                        onClick={() => handleLabelClick(genre)}
                    >
                        {genre}
                    </label>
                ))}
            </div>
            <button className="arrow-btn right" onClick={handleNextClick}>
                <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <rect x="40" y="40" width="40" height="40" rx="20" transform="rotate(180 40 40)" fill="#1F1F22" />
                    <rect x="39.5" y="39.5" width="39" height="39" rx="19.5" transform="rotate(180 39.5 39.5)" stroke="#EBEBFF" stroke-opacity="0.05" />
                    <g clip-path="url(#clip0_1_153)">
                        <path d="M17.9992 25.2002L23.1992 20.0002L17.9992 14.8002" stroke="#FCFCFC" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
                    </g>
                    <defs>
                        <clipPath id="clip0_1_153">
                            <rect width="16" height="16" fill="white" transform="matrix(-1 0 0 -1 28 28)" />
                        </clipPath>
                    </defs>
                </svg>
            </button>
        </div>
    );
}